<template>
    <div class="animated fadeIn">
        <b-form @submit.stop.prevent="onSubmit">


          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
        
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="table.perPage">Linhas</label>
                  <b-form-select v-model="table.perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>

            <b-table
                :items="filteredItems"
                :fields="table.fields"
                :select-mode="table.selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                :primary-key="table.primaryKey"
                :tbody-transition-props="table.transProps"
                sort-icon-left
                :per-page="table.perPage"
                :current-page="table.currentPage"
                :busy="table.isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
               
                <template v-slot:cell(associate)="data">
                   
                   <strong>{{ data.item.user.name }}</strong><br>
                   <div class="container">
                     <div class="row">
                       <div class="col-auto" style="width: 80px">
                         <small>Usuário: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.user.username }}
                       </div>                        
                     </div>
                     <div class="row">
                       <div class="col-auto" style="width: 80px">
                         <small>E-mail: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.user.email }}
                       </div>                        
                     </div>
                     <div class="row">
                       <div class="col-auto" style="width: 80px">
                         <small>Telefone: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.user.phone }}
                       </div>                        
                     </div>
                     <div class="row">
                       <div class="col-auto" style="width: 80px">
                         <small>Grupo: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.group.name }}
                       </div>                        
                     </div>
                   </div>

                 </template>

                  
               <template v-slot:cell(companydata)="data">
                  
                  <strong>{{ data.item.companyName }}</strong><br>
                  
                  <div class="container">
                    <div class="row">
                      <div class="col-auto" style="width: 150px">
                        <small>Ramo de Atividade: </small>
                      </div>
                      <div class="col-sm">
                        {{ data.item.activityBranch ? data.item.activityBranch.name : '' }}
                      </div>                        
                    </div>
                    <div class="row">
                      <div class="col-auto" style="width: 150px">
                        <small>Comissão: </small>
                      </div>
                      <div class="col-sm">
                        {{ data.item.comission && data.item.comission > 0 ? data.item.comission + " %" : '' }}
                      </div>                        
                    </div>
                    <div class="row">
                      <div class="col-auto" style="width: 150px">
                        <small>Indicação/Patrocinador: </small>
                      </div>
                        <div class="col-sm">
                        <i class="fa fa-warning fa-lg mt-4 text-danger" v-show="!(data.item.sponsor && data.item.sponsor.id && data.item.sponsor.id > 0)"></i>
                        {{ data.item.sponsor ? data.item.sponsor.name : data.item.sponsorName }}
                      </div>                
                    </div>
                  </div>
                </template>

                <template v-slot:cell(registration)="data">
                 <div class="container">
                    <div class="row">
                      <div class="col-auto" style="width: 100px">
                        <small>Inscrição: </small>
                      </div>
                      <div class="col-sm">
                        {{ $utils.localDate(data.item.createdIn) }}
                      </div>                        
                    </div>
                    <div class="row">
                      <div class="col-auto" style="width: 100px">
                        <small>Vencimento: </small>
                      </div>
                      <div class="col-sm">
                        {{ data.item.paymentDay }}
                      </div>                        
                    </div>
                    <div class="row">
                      <div class="col-auto" style="width: 100px">
                        <small>Mensalidade: </small>
                      </div>
                      <div class="col-sm">
                        {{ data.item.paymentDay != null ? '23/01/2024' : '' }}
                      </div>                        
                    </div>
                    <div class="row">
                      <div class="col-auto" style="width: 100px">
                        <small>Indicações: </small>
                      </div>
                      <div class="col-sm">
                        {{ data.item.indication != null ? data.item.indication : 0 }}
                      </div>                        
                    </div>
                  </div>

               </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
          
        </b-form>
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  export default {
    name: 'GroupUserComponent',
    props: {
        // Objeto USER
       item: {}
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  this.$utils.filterString(item.user.name, this.filters.key)
                  || this.$utils.filterString(item.activityBranch.name, this.filters.key)
                  || this.$utils.filterString(item.companyName, this.filters.key)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )                  
            })
        }
        catch(e) {
            return this.items;
        }
      },
      componentItem() {
            return this.item
       }
    },
    data: () => {
        return {
          filters: {
            key: '',
            status: 0
          },
          items: [],
          table: {
              fields: [
                  
                  //{key: 'show_details', label: "", thStyle: { width: "40px" } },
                  //{key: 'id' },
                  {key: 'associate', label: 'Associado', sortable: true },
                  {key: 'companydata', label: 'Empresa', sortable: true },
                  {key: 'registration', label: 'Informações do Associado', sortable: false }
                  
                  //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
                  //{key: 'name', label: 'Grupo', sortable: true },
                  //{key: 'weekdayName', label: 'Dia da semana', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
                  //{key: 'meetingTime', label: 'Hora', sortable: true, class: 'text-center', thStyle: { width: "100px" } },
                  //{key: 'memberCount', label: 'Membros', sortable: true, class: 'text-center', thStyle: { width: "80px" } },
                  //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
                  //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
                  //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
                  //{key: 'description', label: 'Descrição', sortable: false },
                  //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
                  //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
                  //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
                  
              ],
              modes: ['multi', 'single', 'range'],
              selectMode: 'multi',
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              perPage: 20,
              primaryKey: "id",
              transProps: {
                  name: 'flip-list'
              },
              isBusy: false
          }
        }
    },
    methods: {
      getRowCount: function () {
          if(this.items)
              return this.items.length
          else
              return 0;
      },
      async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        this.isBusy = true;

        if(s.componentItem.companyId && s.componentItem.id) {
          await axios.get(
              this.$store.state.ws_url + "/franchise/group/user?companyId=" + s.componentItem.companyId + "&groupId=" + s.componentItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.items = resp.data.obj;
          }).catch(function (error) {
              //console.log("ERRO")
              console.log(error.message);
              toast ({
                  type: VueNotifications.types.error,
                  title: 'Associados',
                  message: 'Sem permissão de acesso. Verifique e tente novamente.',
                  timeout: 3000
              })
          });
        }
                
        this.isBusy = false;
        
      },
    },

    mounted: function() {
        this.refreshData()
    }
  }


</script>